import { Wreath } from "@/components/landing/wreath";
import { FadeUp } from "@/components/ui/animated";

/* The template's laurel row, carrying this product's principles rather than a
   store rating it does not have yet. */
const proofs: { label: string; value: string }[] = [
  { label: "Local-first", value: "On device" },
  { label: "Designed around", value: "Official sources" },
  { label: "Your record", value: "Plans ≠ events" },
];

export function Showcase() {
  return (
    <FadeUp delay={0.1}>
      <div className="relative mx-auto mt-12 mb-8 flex w-fit justify-center gap-8 md:my-24 md:gap-20">
        {proofs.map((proof) => (
          <Wreath key={proof.label}>
            <p className="text-[0.625rem] whitespace-nowrap text-muted-foreground md:text-base">
              {proof.label}
            </p>
            <p className="mt-1.5 text-center text-xs font-bold text-balance md:text-2xl">
              {proof.value}
            </p>
          </Wreath>
        ))}
      </div>
    </FadeUp>
  );
}
